import React from "react"
import { ThemeProvider } from "styled-components"
import { Theme } from "./theme/Theme"
import { Article, Home } from "./templates/Index"
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import Preview from "./utils/Preview"
import BlogState from "./context/BlogState"
import LoadingScreen from "./utils/LoadingScreen"
import { HelmetProvider } from "react-helmet-async"
// import NotFound from './NotFound'

export function App() {
	return (
		<BlogState>
			<HelmetProvider>
				<ThemeProvider theme={Theme}>
					<Router>
						<Switch>
							<Route exact path={"/blogs/all"}>
								<Home />
							</Route>
							<Route path={"/blogs/all/tagged/:slug"}>
								<Home />
							</Route>
							<Route path={"/loading"}>
								<LoadingScreen />
							</Route>
							<Route path={"/blogs/all/:slug"}>
								<Article />
							</Route>
							{/* Add the new preview route here */}
							<Route exact path="/preview" component={Preview} />
							{/* <Route component={NotFound} /> */}
						</Switch>
					</Router>
				</ThemeProvider>
			</HelmetProvider>
		</BlogState>
	)
}
